var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"advice-alert"},[_c('w-alert-circle',{attrs:{"status":_vm.alert.status}}),_vm._v(" "+_vm._s(_vm.alert.text)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }